<template>
    <div>
        <el-row type="flex" justify="center" v-loading.fullscreen.lock="loading" element-loading-text="小微帮您拼命加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-col :span="12">
                    {{app ? app.app_name : ''}}.数据统计
                </el-col>
            </el-row>
        <el-container>
            <el-aside width="180px">
                <SubMenu activeIndex="7" />
            </el-aside>
            <el-main>
                <el-row>
                    <!-- <el-col :span="4">
                        选择要查找的日期:
                    </el-col> -->
                    <el-col :span="7">
                        <el-date-picker size="mini" v-model="date" type="date" placeholder="选择日期" @change="searchBydate(date)" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="12">
                        <el-date-picker size="mini" v-model="date_between" type="daterange" @change="searchBydateBetween(date_between)" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-col>
                </el-row>
                <hr class="line" />
                <div v-if="rawData.length > 0" class="table">
                    <el-row>
                        <el-col :span="5">
                            <download-excel class="btn btn-default" :data="json_data" :fields="json_fields" :name="excel_name">
                                <el-button type="success" size="mini" icon="el-icon-document" plain>导出数据到excel</el-button>
                            </download-excel>
                        </el-col>
                        <el-col :span="13">
                            <el-input v-model="duixiang_name_kw" @blur="searchByname(duixiang_name_kw)" @keyup.enter.native="searchByname(duixiang_name_kw)" @input="searchByname(duixiang_name_kw)" size="mini" placeholder="对象名关键字查找" />
                        </el-col>
                    </el-row>
                    <el-row style="margin:20px 0">
                        <Tag color="teal" @click.native="showAll">显示全部</Tag>
                        <Tag color="#67c23a" @click.native="hideUnchecked">隐藏未检查</Tag>
                        <Tag v-for="(tag, index) in tags" checkable :checked="tag['is_checked'] ? true : false" @click.native="searchByTag(tag, index)" class="tag" color="#008080" :key="index">{{tag.tag_name}}</Tag>
                    </el-row>
                    <el-table :row-class-name="tableRowClassName" :data="cur_page_duixiangs" border style="width: 100%">
                        <el-table-column label="对象名">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.is_checked">
                                    {{ scope.row.duixiang_name +'(未检查)' }}
                                </span>
                                <span v-else>{{ scope.row.duixiang_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-for="(option,index) in cur_page_duixiangs[0].options" :label="option.option_name">
                            <template slot-scope="scope">
                                <span>
                                    {{scope.row.options[index].option_num}}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="block">
                        <el-pagination :current-page="page.cur_page" :page-size="page.page_size" layout="prev, pager, next" :total="page.total" @current-change="currentChange">
                        </el-pagination>
                    </div>
                </div>
                <div v-else style="margin-top: 200px">
                    无检查数据,请通过日期查找
                </div>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import axios from 'axios'
import config from '../config.js'
import SubMenu from './SubMenu.vue'
import { Tag } from 'iview';
import JsonExcel from 'vue-json-to-excel';
export default {
    components: {
        SubMenu,
        Tag,
        downloadExcel: JsonExcel
    },
    data() {
        return {
            loading: false,
            app_id: '',
            app: null,
            items: [],
            duixiangs: [],
            cur_page_duixiangs: [],
            page: {
                cur_page: 1,
                total: 0,
                page_size: 10

            },
            showing_duixiangs: [],
            duixiang_name_kw: '',
            tags: [],
            tags_ids: [],
            date: '',
            date_between: '',
            rawData: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            },
            json_fields: {

            },
            json_data: [],
            excel_name: ''

        }

    },
    created() {
        this.loading = true;
        this.app_id = this.$route.params.app_id
        if (!localStorage.getItem(this.app_id)) {
            this.getApp()
        } else {

            let app = JSON.parse(localStorage.getItem(this.app_id))
            this.setApp(app)
            this.getDuixiang()
            this.getTags()
        }


    },
    methods: {

        getApp() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                localStorage.setItem(response.data.app_id, JSON.stringify(response.data))
                this.setApp(res)
                this.getDuixiang()
                this.getTags()
            }).catch((err) => {
                //console.log(err);
            })
        },
        setApp(app) {
            this.app = app

        },
        getTags() {
            //console.log('getTags')
            let url = config.base_url + '/yun_table/yun_duixiang_tags?group_id=' + this.app.jcdx_group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                this.tags = response.data
            })
        },
        getDuixiang() {
            let url = config.base_url + '/yun_table/yun_duixiang?group_id=' + this.app.jcdx_group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.duixiangs = res
                this.page.total = res.length
                this.showing_duixiangs = res
                this.getItem()
                //this.showCurDuixiang()
                this.searchToday()
                
            })
        },
        searchToday(){
            let today = new Date()
            let day = today.getDate()
            let year = today.getFullYear()
            let month = today.getMonth() + 1
            this.date = year + '-' + month + '-' + day
            let _this = this
            setTimeout(function(){
                //console.log(1)
                _this.searchBydate(_this.date)
                _this.loading = false
            },500)

        },
        showCurDuixiang() {
            
            let cur_page = this.page.cur_page
            //console.log(cur_page)
            let page_size = this.page.page_size
            let duixiangs = this.duixiangs
            let showing_duixiangs = this.showing_duixiangs
            this.cur_page_duixiangs = []
            if (showing_duixiangs.length > 0) {
                //cur_page = 1
                this.page.total = showing_duixiangs.length
                let cur_page_duixiangs = showing_duixiangs.slice((cur_page - 1) * page_size, (cur_page - 1) * page_size + page_size)
                this.cur_page_duixiangs = cur_page_duixiangs
            }

        },
        currentChange(cur_page) {
            //console.log(cur_page)
            this.page.cur_page = cur_page
            this.showCurDuixiang()

        },
        showAll() {
            //this.showing_duixiangs = []
            this.showing_duixiangs = this.duixiangs
            this.page.cur_page = 1
            this.showCurDuixiang()
            this.tags_ids = []
            for (let i = 0; i < this.tags.length; i++) {
                this.tags[i].is_checked = false
            }
        },
        searchByTag(tag, index) {
            let tags_ids = this.tags_ids
            let duixiangs = this.duixiangs
            this.page.cur_page = 1
            //console.log(index)
            function hasTag() {
                if (tags_ids.length > 0) {
                    for (let i = 0; i < tags_ids.length; i++) {
                        if (tags_ids[i] == tag.tag_id) {
                            return true
                        }
                    }
                }
                return false
            }
            if (hasTag()) {
                //console.log(index)
                this.tags_ids.splice(this.arrIndex(tag.tag_id, tags_ids), 1)
                this.tags[index].is_checked = false
                if (this.tags_ids.length < 1) {
                    this.showAll()
                    return false
                }

                //console.log(t)
            } else {
                this.tags_ids.push(tag.tag_id)
                this.tags[index].is_checked = true
            }
            this.showing_duixiangs = []
            for (let i = 0; i < duixiangs.length; i++) {
                if (duixiangs[i].tags.length < 1) {
                    continue;
                }
                let dx_tag_id = []
                for (let j = 0; j < duixiangs[i].tags.length; j++) {
                    dx_tag_id.push(duixiangs[i].tags[j].tag_id)
                    // if(this.inArray(duixiangs[i].tags[j].tag_id, tags_ids)){
                    //  this.showing_duixiangs.push(duixiangs[i])
                    // }
                }
                if (this.arrInArray(this.tags_ids, dx_tag_id)) {
                    this.showing_duixiangs.push(duixiangs[i])
                }

            }
            this.showCurDuixiang()

        },
        searchByname(kw) {
            //console.log(kw)
            if (!kw) {
                this.showAll()
                return false
            }
            let duixiangs = this.duixiangs
            this.page.cur_page = 1
            if (kw) {
                //this.cur_page_duixiangs = []
                this.showing_duixiangs = []
                let patten = new RegExp(kw)
                for (let i = 0; i < duixiangs.length; i++) {
                    if (patten.test(duixiangs[i].duixiang_name)) {
                        //this.cur_page_duixiangs.push(duixiangs[i])
                        this.showing_duixiangs.push(duixiangs[i])
                    }
                }
            }
            this.duixiang_name_kw = ''
            this.showCurDuixiang()

        },
        inArray(item, arr) {
            for (let i = 0; i < arr.length; i++) {
                if (item == arr[i]) {
                    return true
                }
            }
        },
        arrInArray(arr1, arr2) {
            if (arr1.length < 1) {
                return false
            }
            for (let i = 0; i < arr1.length; i++) {
                if (!this.inArray(arr1[i], arr2)) {
                    return false
                }
            }
            return true
        },
        arrIndex(item, arr) {
            for (let i = 0; i < arr.length; i++) {
                if (item == arr[i]) {
                    return i
                }
            }
            return -1
        },

        getItem() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app.app_id + '/items'
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.items = res

            }).catch((err) => {
                //console.log(err);
            })
        },
        searchBydate(date) {
            //console.log(date)

            this.date_between = ''
            this.json_data = []
            this.excel_name = this.app.app_name + '(' + date + ')' + '.xls'
            axios({
                    method: 'get',
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    url: config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id + '/res?start_date=' + date,
                })
                .then((response) => {
                    //console.log(response)

                    this.rawData = response.data
                    this.createTableData()

                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                })
        },
        searchBydateBetween(date_between) {
            //console.log(date_between)
            this.date = ''
            this.json_data = []
            this.excel_name = this.app.app_name + '(' + date_between[0] + '----' + date_between[1] + ')' + '.xls'
            axios({
                    method: 'get',
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    url: config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id + '/res?start_date=' + date_between[0] + '&end_date=' + date_between[1],
                })
                .then((response) => {
                    //console.log(response)

                    this.rawData = response.data
                    this.createTableData()

                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                })
        },
        createTableData() {
            let duixiangs = this.duixiangs
            let items = this.items
            let rawData = this.rawData
            for (let d = 0; d < duixiangs.length; d++) {
                this.duixiangs[d].options = []
                this.duixiangs[d].is_checked = false
                for (let i = 0; i < items.length; i++) {
                    for (let j = 0; j < items[i].options.length; j++) {

                        let title = items[i].item_name + '/' + items[i].options[j].option_name
                        this.duixiangs[d]['options'].push({
                            option_name: title,
                            option_num: 0,
                            option_id: items[i].options[j].option_id,
                        })
                    }

                }
            }
            duixiangs = this.duixiangs
            for (let i = 0; i < duixiangs.length; i++) {
                for (let j = 0; j < duixiangs[i].options.length; j++) {
                    for (let k = 0; k < rawData.length; k++) {
                        if (rawData[k].jcdx_id != duixiangs[i].duixiang_id) {
                            continue;
                        }
                        if (rawData[k].option_id == duixiangs[i].options[j].option_id) {
                            this.duixiangs[i].options[j].option_num += 1
                            this.duixiangs[i].is_checked = true
                        }
                    }
                }
            }

            //组建导出excel数据
            let first_row_data = {
                name: '对象名称',
                tags: '标签'
            }
            this.json_fields.name = 'duixiang_name'
            for (let i = 0; i < duixiangs[0].options.length; i++) {
                first_row_data[duixiangs[0].options[i].option_name] = duixiangs[0].options[i].option_name
            }

            for (let i = 0; i < duixiangs.length; i++) {
                let dt = {}
                dt.name = duixiangs[i].duixiang_name
                dt.tags = ''
                for (let j = 0; j < duixiangs[i].tags.length; j++) {
                    dt['tags'] += duixiangs[i].tags[j].tag_name + ','
                }
                for (let j = 0; j < duixiangs[i].options.length; j++) {
                    dt[duixiangs[i].options[j].option_name] = duixiangs[i].options[j].option_num
                }

                if (i == 0) {

                    this.json_data.push(first_row_data)

                }
                this.json_data.push(dt)
            }



            this.showAll()
            this.showCurDuixiang()

        },
        tableRowClassName({ row, rowIndex }) {
            if (!row.is_checked) {
                return 'warning-row';
            }
            return '';
        },
        hideUnchecked(){
            let duixiangs = this.duixiangs
            this.page.cur_page = 1
            
                //this.cur_page_duixiangs = []
                this.showing_duixiangs = []
                for (let i = 0; i < duixiangs.length; i++) {
                   if(duixiangs[i].is_checked){
                    this.showing_duixiangs.push(duixiangs[i])
                   }
                }
            
            this.showCurDuixiang()
        }
    },

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-table .warning-row {
    background: oldlace;
}

.line {
    display: block;
    margin: 20px;
    border: 0.5px dotted #027979;

}

.table {
    margin-top: 30px;
}
</style>